import PSCampaign from "PSCampaign";
import * as unity from "./unity.js";

const div = "#campaignOverLayer";
export let carousel;
const onCarouselClosedCallbacks = [];
let avoidHideCarousel = false;
let fromBase64Build = false;

export function init() {
    console.log("[w] init campaigns");
    carousel = new PSCampaign.Carousel(div, document.body.clientHeight);
    unity.onResize(function (_, canvas) {
        carousel.height = canvas.height;
    });
}

export function setAvoidHideCarousel(val) {
    avoidHideCarousel = val;
}

export function hideCarousel() {
    if (avoidHideCarousel) {
        console.log("[w] hideCarousel avoided by external agent");
        return;
    }

    console.log("[w] hideCarousel", fromBase64Build);
    carousel.hide();
    carousel.clean();
    carousel.removeObservers();
    onCarouselClosedCallbacks.forEach(c => c());
    if (fromBase64Build) sendCarouselClosed();
    fromBase64Build = false;
}

export function buildCarousel(actionBase64DataString) {
    console.log("[w] buildCarousel: ", actionBase64DataString);

    hideCarousel();

    fromBase64Build = true;
    carousel.registerObserver(onActionDecision);
    let campaignData = JSON.parse(atob(actionBase64DataString));
    carousel.generate(campaignData);
    sendCarouselReady();
}

export function executeActionDecision(idActionDecision) {
    console.log("[w] executeActionDecision: ", idActionDecision);
    carousel.show(idActionDecision);
}

export function executeMessagePackUpdate(data, idActionDecision, frameMessageType) {
    console.log("[w] executeMessagePackUpdate: ", data);
    carousel.message(idActionDecision, frameMessageType, data);
}

function onActionDecision(_, idActionDecision, response) {
    console.log("[w] onActionDecision: ", idActionDecision, response);
    let params = {};
    if (response.type === PSCampaign.FrameMessageType.KILL) {
        params = {
            type: "close",
            status: "KO",
            message: "",
            zoneId: "0",
        };
        hideCarousel();
    } else {
        params = {
            type: "action",
            idActionDecision: idActionDecision.toString(),
            response: JSON.stringify(response)
        };
    }
    unity.sendData(unity.webViewPlugin, params);
}

export function sendCarouselReady() {
    unity.sendData(unity.webViewPlugin, {
        type: "ready",
        status: "OK"
    });
}

function sendCarouselClosed() {
    unity.sendData(unity.webViewPlugin, {
        type: "close"
    });
}

export function onCarouselClosed(callback) {
    if (typeof callback === "function") {
        onCarouselClosedCallbacks.push(callback);
    }
}